import React from 'react'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Actions
import { getInterestsFeed } from '../../../../actions/interests'

// Universal Components
import { MetaData } from '../../../../components'
import { TextLoader } from '../../../../components/Loaders'

// Relative Components
import { ContentTypes, Post, Video } from './components'
import {isModalChild} from "~/services/url-analysis";

// Define the filters
const filters = {
	'all': 'All',
	'articles': 'Articles',
	'workshops': 'Workshops',
	'videos': 'Videos'
}

class Filtered extends React.Component {

    constructor(props) {
        super(props);

        if( !props.sessionsAllowed ) {
            delete filters.workshops;
        }

        const { filter = 'all' } = props.match.params;
        this.state = {
        	filter: { slug: filter, title: filters[filter] }
		};
    }

    componentDidMount(prevProps) {
		let { interests, match, location, getInterestsFeed } = this.props,
			{ interest } = interests;

		const isModalChild = prevProps && isModalChild(prevProps.location, location);

		if( ( !isModalChild && !('slug' in interest && interest.slug === match.params.slug) ) || (interests && !interests.feed.length) ) {
            getInterestsFeed(match.params.slug);
        }
	}

    getContent = (content) => {

		if( content.length < 1 ) return <p className="text-center mtop40 text-dark-gray">No content under this interest yet</p>;

		let isAll = this.state.filter.slug !== 'all'

		let c = content;
        if( !this.props.sessionsAllowed ) {
            c = c.filter( post => (post.post_type.plural_lower !== 'workshops') )
        }
	
		return c.filter( post => {
			let { slug } = this.state.filter;
			if( slug === 'videos' ) slug = 'statements'
			if( isAll && post.post_type.plural_lower !== slug ) return false;

			return true;

		} )
            .map( post => {
                return (
                    <div
                        className="col-md-4 col-sm-6 col-xs-12 mbot20 post-preview"
                        key={'interest-post-'+post.ID}
                    >
                        { post.post_type.singular_lower === 'statement'
                            ? <Video {...post} />
                            : <Post {...post} />
                        }
                    </div>
                )
            } );

	};

    render() {
		if(!this.props.interests) return null;

		let fetching, feed, interest;
		
		if(this.props.interests) {
			fetching = this.props.interests.fetching ? this.props.interests.fetching.feed : false;
			feed = this.props.interests.feed;
			interest = this.props.interests.interest;
		}

		let { filter } = this.state,
			fullFeed = feed ? this.getContent(feed) : [],
			{ stored } = this.props.notifications;

		if( !!fetching ) return <TextLoader />;

		return (
			<div className="pbot40">

				<MetaData page="interest" vars={interest} />

				<ContentTypes interest={interest} filter={filter.slug} filters={filters} />

				{ interest && <h1 className="mbot30">{ interest.title } { filter.slug !== 'all' ? filter.title : '' } { '('+fullFeed.length+')' }</h1> }
				
				{ !!fullFeed.length
					? <div className="row pbot30 flex-wrap">{fullFeed}</div>
					: <p className="text-center">No { filter.slug !== 'all' ? filter.title : 'Posts' }!</p> 
				}
        		
			</div>
		)
		
	}
}

const mapStateToProps = state => ({
    interests: state.interests,
    notifications: state.notifications,
    sessionsAllowed: state.session.sessionsAllowed
});

const mapDispatchToProps = dispatch => bindActionCreators({ getInterestsFeed }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( withRouter(Filtered) );




// WEBPACK FOOTER //
// ./src/js/views/Discover/scenes/Filtered/index.jsx